// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"0ec7b35e","453":"2b2e62d7","732":"a256e6d4"}[chunkId] + ".chunk.js";
};